/**
 * Motivational quotes for watermarks
 */

export const motivationalQuotes: string[] = [
  // Core mindset
  "I'm doing great!",
  "Let's go!",
  "Seize the day!",
  "I show up strong.",
  "I choose progress.",
  "Today is a win!",
  "I can do this.",
  "One step forward.",
  "I stay focused.",
  "I am capable.",
  "I believe in myself!",
  "I stay consistent.",
  "I finish strong.",
  "I am improving.",
  "Today matters!",
  "I take action.",
  "I stay disciplined.",
  "I handle challenges.",
  "I bring good energy.",
  "I attract success!",
  "I do my best.",
  "I learn daily.",
  "I adapt fast.",
  "I stay optimistic.",
  "I create momentum.",
  "I work with purpose.",
  "I stay calm.",
  "I manage my time.",
  "I grow daily.",
  "I stay confident.",
  "I stay present.",
  "I handle pressure.",
  "I act with integrity.",
  "I am resilient.",
  "I bounce back!",
  "I stay grounded.",
  "I trust myself.",
  "I welcome growth.",

  // Work & execution
  "Do the work.",
  "Make it happen!",
  "Action beats fear.",
  "Consistency wins!",
  "Execution beats ideas.",
  "Focus fuels growth.",
  "Momentum matters!",
  "Progress over perfection.",
  "Small wins count.",
  "Step by step.",
  "Brick by brick.",
  "Build the habit.",
  "Now is enough.",
  "Just begin!",
  "Move the needle.",
  "Every bit counts.",
  "Results will come.",
  "Push with purpose.",
  "Forward only.",
  "Win the day!",
  "Show up daily.",
  "Never drift.",
  "Stay aligned.",
  "Eyes on the goal!",
  "Keep pushing!",
  "Do it right.",
  "Stay committed.",
  "Stable progress.",
  "Solid execution.",
  "Focus now!",
  "Choose discipline.",
  "Trust the process.",

  // Energy & confidence
  "Great energy today!",
  "Positive vibes only!",
  "Calm and confident.",
  "Locked in!",
  "Ready to win!",
  "Built for this.",
  "All in!",
  "Eyes forward.",
  "Bring it on!",
  "Strong mindset.",
  "Clear goals.",
  "Stand tall!",
  "Better every day.",
  "Mindset first.",
  "Full focus!",
  "Go time!",
  "On point!",
  "Make today count!",

  // Customer & service mindset
  "I treat customers right.",
  "Customers come first.",
  "Service comes first.",
  "I always smile!",
  "I listen first.",
  "I care genuinely.",
  "I stay professional.",
  "I keep my promises.",
  "I go the extra mile.",
  "I earn trust daily.",
  "I stay polite.",
  "I stay helpful.",
  "I create good vibes!",
  "Customers feel welcome.",
  "Kindness is power.",
  "Listening builds trust.",
  "Respect builds loyalty.",
  "Service is success!",
  "Care creates value.",
  "Professional always.",
  "Quality first.",
  "People remember kindness.",

  // Leadership & responsibility
  "I lead myself.",
  "I take responsibility.",
  "I own outcomes.",
  "I stay accountable.",
  "I deliver results.",
  "I am dependable.",
  "I stay solution-driven.",
  "I manage stress.",
  "I stay sharp.",
  "I move with purpose.",
  "I choose excellence.",
  "I lead with kindness.",
  "I bring clarity.",
  "I stay organized.",
  "I am prepared.",
  "I value effort.",
  "I respect time.",

  // Daily affirmations
  "Today I win!",
  "Today I build.",
  "Today I act.",
  "Today I serve.",
  "Today I improve.",
  "Today I focus.",
  "Today I lead.",
  "Today I care.",
  "Today I grow.",
  "I handle today.",
  "This is my moment!",
  "I am ready.",
  "I am steady.",
  "I am focused.",
  "I am helpful.",
  "I am driven.",
  "I am consistent.",
  "I am committed.",
  "I stay strong!",
  "I keep momentum.",

  // ---- EXTRA QUOTES (ADD BELOW) ----
"Let's stay sharp!",
"Let's stay focused.",
"Let's keep moving!",
"Let's build momentum.",
"Let's win today!",
"Let's execute well.",
"Let's do great work!",
"Let's finish strong!",
"Let's serve well.",
"Let's stay kind.",

"Momentum over moods.",
"Progress feels good.",
"Clarity creates speed.",
"Energy drives results.",
"Focus creates wins.",
"Consistency compounds.",
"Discipline shows today.",
"Effort always matters.",
"Details make the difference.",
"Quality shows up.",

"Stay ready.",
"Stay steady!",
"Stay sharp.",
"Stay patient.",
"Stay proactive.",
"Stay alert!",
"Stay positive!",
"Stay engaged.",
"Stay intentional.",
"Stay humble.",

"I keep standards high.",
"I respect the process.",
"I value execution.",
"I choose excellence.",
"I bring solutions.",
"I show professionalism.",
"I act with purpose.",
"I stay flexible.",
"I stay reliable.",
"I stay composed.",

"Work with pride.",
"Serve with heart.",
"Lead with example.",
"Act with clarity.",
"Move with intention.",
"Build real trust.",
"Care shows always.",
"Service sets us apart.",
"Respect earns loyalty.",
"Kindness builds brands.",

"Every task matters.",
"Every customer counts.",
"Every action counts.",
"Every effort counts.",
"Every detail matters.",
"Every moment counts.",
"Start with care.",
"Finish with pride.",

"Less talk, more action.",
"Quiet execution wins.",
"Strong habits win!",
"Focus beats talent.",
"Effort beats excuses.",
"Systems bring calm.",
"Consistency brings confidence.",
"Clarity beats rush.",
"Discipline beats motivation.",

"Good work feels right.",
"Clean execution wins.",
"Calm creates control.",
"Confidence grows daily.",
"Progress is happening.",
"Growth shows up.",
"Results are coming!",
"Trust is building.",
"Standards are rising.",

"Customers feel valued.",
"Customers feel heard.",
"Customers feel respected.",
"Service feels natural.",
"Help comes first.",
"Care is visible.",
"Trust feels earned.",
"Loyalty grows here.",
"Value is delivered.",

"Breathe and execute.",
"Control the pace.",
"Own the moment.",
"Handle it well.",
"Do it once right.",
"Take the lead.",
"Move forward now!",
"Finish what matters.",
"Stay the course.",

"Win the small moments.",
"Do small things well.",
"Details build results.",
"Habits show results.",
"Effort compounds daily.",
"Progress stacks up.",
"Momentum is real!",
"Confidence builds daily.",

"Strong focus today!",
"Solid work today!",
"Great mindset today!",
"Good energy today!",
"Clean execution today!",
"Clear thinking today!",
"Sharp decisions today!",
"Steady progress today!",
"Positive actions today!",

"Respect the work.",
"Respect the craft.",
"Respect the customer.",
"Respect the process.",
"Respect the standard.",

"Now we move!",
"Time to focus!",
"Time to execute!",
"Time to deliver!",
"Time to serve!",
"Time to win!",


  // Short punchy
  "Game on!",
  "Let’s do this!",
  "Energy up!",
  "All set!",
  "Ready now!",
  "Bring the energy!",
  "Locked and loaded!",
  "Win with grace.",
  "Go again!",
  "Start strong!",
  "Finish better!",
  "Show discipline.",
  "Stay sharp!",
  "Clarity wins.",
  "Focus wins!",
];

/**
 * Returns a random motivational quote
 */
export function getRandomQuote(): string {
  const index = Math.floor(Math.random() * motivationalQuotes.length);
  return motivationalQuotes[index];
}
